import { render } from "./DeviceAuditLogs.vue?vue&type=template&id=107e6024"
import script from "./DeviceAuditLogs.vue?vue&type=script&lang=js"
export * from "./DeviceAuditLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__